/* PKW GUTACHTER - Sprungmarken
   ==========================================================================
   Verweise innerhalb derselben Seite (href="#irgendwas").

   WAS KAPUTT WAR

   Auf /pages/faqs stehen oben drei solche Verweise: Allgemeine Fragen,
   Alles zur Unfallstelle, Versicherungsfragen. Ein Klick darauf tat drei
   Dinge, von denen zwei falsch waren.

   maximal.js kommt aus einem Entwurf, in dem die ganze Seite im Browser
   umgeschaltet wurde - drei Unterseiten hinter Rautezeichen. Davon sind
   zwei Zuhoerer auf hashchange uebrig:

     1. Der Umschalter. Er sucht zu jeder Raute eine passende .seite und
        faellt, wenn er keine findet, auf "start" zurueck - und die zeigt
        er dann mit window.scrollTo(0,0). Bei Shopify gibt es immer nur
        die eine Seite namens "start", also trifft das jede Raute.
     2. Der Wischer. Acht Balken fahren ueber den Bildschirm, wie beim
        Wechsel auf eine andere Seite.

   Dazu kam ein dritter Fehler, der nichts mit maximal.js zu tun hat: Die
   Kopfzeile bleibt beim Scrollen oben stehen und ist 79 Pixel hoch. Ein
   Browser scrollt eine Sprungmarke an die Oberkante des Fensters - also
   genau unter die Kopfzeile. Die Ueberschrift, zu der man springen
   wollte, lag danach hinter der Kopfzeile.

   Gemessen sah das so aus: Ziel bei 1846 Pixeln, gelandet einmal bei
   1846 (Ueberschrift unter der Kopfzeile) und beim naechsten Versuch bei
   1738 - also 108 Pixel daneben. Der Unterschied kommt daher, dass der
   Umschalter, der Wischer und die Aufklapper des Entwurfs sich nach dem
   Sprung noch in die Seitenhoehe einmischen. Was dabei herauskommt, ist
   ein Wettrennen, und Wettrennen gewinnt mal der eine und mal der andere.

   WIE ES JETZT LAEUFT

   Der Klick wird abgefangen, bevor der Browser die Raute in die Adresse
   schreibt. Ohne Aenderung der Raute gibt es kein hashchange - damit sind
   Umschalter und Wischer aus dem Spiel, ohne dass an maximal.js etwas
   geaendert werden muesste. Gescrollt wird selbst, weich, und um die
   Hoehe der Kopfzeile plus etwas Luft versetzt. Die Adresse wird
   anschliessend per pushState nachgetragen: gleiche Adresse zum Kopieren
   und Teilen, aber wieder ohne hashchange.

   Zwei Dinge, die leicht vergessen werden und hier drinstehen:

   Der Fokus wandert auf das Ziel. Ohne das liest ein Vorleseprogramm nach
   dem Sprung an der alten Stelle weiter, und die naechste Tabulatortaste
   fuehrt zurueck an den Seitenanfang. Weil Ueberschriften von Haus aus
   keinen Fokus annehmen, bekommen sie dafuer tabindex="-1".

   Und eine Adresse, die schon mit Raute aufgerufen wird (jemand hat den
   Verweis geteilt), wird ebenfalls versetzt angesprungen - zweimal sogar,
   einmal gleich und einmal nach dem Laden der Bilder, weil sich bis dahin
   die halbe Seite noch verschiebt.
   ========================================================================== */
(function () {
  "use strict";

  var mq = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");

  function hoehe() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function rand() {
    var k = document.querySelector(".site-head");
    var h = k ? Math.round(k.getBoundingClientRect().height) : 80;
    return h + 18;
  }

  function ziel(raute) {
    if (!raute || raute.length < 2) { return null; }
    var name = raute.slice(1);
    var el = document.getElementById(name);
    if (!el) {
      try { el = document.getElementById(decodeURIComponent(name)); } catch (e) {}
    }
    if (!el) { el = document.getElementsByName(name)[0] || null; }
    return el;
  }

  function springe(el, weich) {
    var y = Math.round(el.getBoundingClientRect().top + hoehe() - rand());
    if (y < 0) { y = 0; }
    var glatt = weich && !(mq && mq.matches);
    try {
      window.scrollTo({ top: y, behavior: glatt ? "smooth" : "auto" });
    } catch (e) {
      window.scrollTo(0, y);
    }
  }

  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
    var a = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!a) { return; }
    if (a.target && a.target !== "" && a.target !== "_self") { return; }
    if (a.hasAttribute("download")) { return; }

    var href = a.getAttribute("href") || "";
    var i = href.indexOf("#");
    if (i < 0) { return; }

    /* Nur Verweise auf DIESE Seite. Alles davor muss leer sein oder genau
       der aktuelle Pfad - sonst ist es ein Verweis auf eine andere Seite,
       der zufaellig eine Raute mitbringt, und der gehoert dem Browser. */
    var vorn = href.slice(0, i);
    if (vorn !== "" && vorn !== location.pathname && vorn !== location.pathname + location.search) { return; }

    var raute = href.slice(i);
    var el = ziel(raute);
    if (!el) { return; }

    e.preventDefault();
    springe(el, true);

    try { history.pushState(null, "", raute); } catch (err) {}

    if (!el.hasAttribute("tabindex")) { el.setAttribute("tabindex", "-1"); }
    try { el.focus({ preventScroll: true }); } catch (err) {}
  });

  if (location.hash && location.hash.length > 1) {
    var start = ziel(location.hash);
    if (start) {
      setTimeout(function () { springe(start, false); }, 140);
      window.addEventListener("load", function () {
        setTimeout(function () { springe(start, false); }, 80);
      });
    }
  }
})();
